// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { 
  getAuth, 
  onAuthStateChanged, 
  sendEmailVerification, 
  updateProfile, 
  createUserWithEmailAndPassword 
} from 'firebase/auth';

import { 
  getFirestore, 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  addDoc, 
  getDocs,
  updateDoc,       // ✅ Added
  deleteDoc        // ✅ Added
} from 'firebase/firestore';

import { getStorage } from 'firebase/storage'; // Import for Firebase Storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDRiOnyH8vvMEPBtxulkxdiaKnOothTYQQ",
  authDomain: "kibalo-tool.firebaseapp.com",
  projectId: "kibalo-tool",
  storageBucket: "kibalo-tool.firebasestorage.app",
  messagingSenderId: "961896846463",
  appId: "1:961896846463:web:52a5dc0182d4cff32f5b4a",
  measurementId: "G-STHNNJY6LX"
};

// Initialize Firebase
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Export the services needed for auth, Firestore and Storage
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export {
  auth,
  db,
  storage,
  analytics,
  collection,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  updateDoc,      // ✅ Exported
  deleteDoc,      // ✅ Exported
  onAuthStateChanged,
  sendEmailVerification,
  updateProfile,
  createUserWithEmailAndPassword
};

// Firestore helper — save user object
export const createUserInFirestore = async (userId, userData) => {
  const userRef = doc(db, 'users', userId);
  await setDoc(userRef, userData, { merge: true });
};

// Create a new Kibalo under specific user
export const createKibalo = async (userId, kibaloData) => {
  const kibalosRef = collection(db, 'users', userId, 'kibalos');
  const newKibaloDoc = await addDoc(kibalosRef, kibaloData);
  return newKibaloDoc.id;
};

// Fetch all kibalos for a user
export const fetchKibalosForUser = async (userId) => {
  const kibalosRef = collection(db, 'users', userId, 'kibalos');
  const kibalosSnapshot = await getDocs(kibalosRef);
  return kibalosSnapshot.docs.map(doc => doc.data());
};

// Fetch a single kibalo
export const fetchKibaloById = async (userId, kibaloId) => {
  const kibaloRef = doc(db, 'users', userId, 'kibalos', kibaloId);
  const kibaloSnapshot = await getDoc(kibaloRef);
  if (kibaloSnapshot.exists()) {
    return kibaloSnapshot.data();
  } else {
    console.error("No such kibalo!");
    return null;
  }
};
